var React = require('react');

function ArrowSmall (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"transform":"rotate(180) translate(-18, -8)","y":"3.5","className":"st0","width":"18","height":"1","fill":"#1368ea","key":0}),React.createElement("path",{"className":"st0","d":"M18.4,4.4c0.2-0.2,0.2-0.5,0-0.7l-3.2-3.2c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7L17.3,4l-2.8,2.8c-0.2,0.2-0.2,0.5,0,0.7c0.2,0.2,0.5,0.2,0.7,0L18.4,4.4z","fill":"#1368ea","key":1})]);
}

ArrowSmall.defaultProps = {"width":"19","height":"8","viewBox":"0 0 19 8","fill":"none"};

module.exports = ArrowSmall;

ArrowSmall.default = ArrowSmall;
